function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import classNames from 'classnames';
import styles from './MenuItem.scss';

var MenuItem = function MenuItem(_ref) {
  var label = _ref.label,
      onClick = _ref.onClick;
  return /*#__PURE__*/React.createElement("div", {
    className: classNames(styles.MenuItem, _defineProperty({}, styles.MenuItem_clickable, !!onClick)),
    onClick: onClick
  }, label);
};

export default MenuItem;